module.exports = __webpack_public_path__ + "img/matt_n_2.51701b4b.png";